class ModifiedSectionsTracker {

  constructor() {

    this.modifiedSections = [];
    this.onRemindersChange = function onRemindersChange() {

    };

  }

  tryAddToModifiedSectionsList(sectionName) {

    if (this.modifiedSections.indexOf(sectionName) === -1) {
      this.modifiedSections.push(sectionName);
    }

    this.saveButton.setDisabled(this.modifiedSections.length === 0);

  }

  tryRemoveFromModifiedSectionsList(sectionName) {

    const index = this.modifiedSections.indexOf(sectionName);

    if (index !== -1) {
      this.modifiedSections.splice(index, 1);
    }

    this.saveButton.setDisabled(this.modifiedSections.length === 0);

  }

  handleBasicDetailsChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('BasicDetailsSection');
    } else {
      this.tryRemoveFromModifiedSectionsList('BasicDetailsSection');
    }

  }

  handleScheduleChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('ScheduleSection');
    } else {
      this.tryRemoveFromModifiedSectionsList('ScheduleSection');
    }

  }

  handleParticipantsChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('ParticipantsSection');
    } else {
      this.tryRemoveFromModifiedSectionsList('ParticipantsSection');
    }

  }

  handleLocationChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('LocationSection');
    } else {
      this.tryRemoveFromModifiedSectionsList('LocationSection');
    }

  }

  handleRemindersChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('RemindersSection');
    } else {
      this.tryRemoveFromModifiedSectionsList('RemindersSection');
    }

    this.onRemindersChange(event);

  }

  handleTagsChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('TagsSection');
    } else {
      this.tryRemoveFromModifiedSectionsList('TagsSection');
    }

  }

  resetModifiedStates() {

    this.modifiedSections = [];

    this.saveButton.setDisabled(this.modifiedSections.length === 0);

  }

  handlePriorityChange(event) {

    if (event.modified === true) {
      this.tryAddToModifiedSectionsList('PrioritySection');
    } else {
      this.tryRemoveFromModifiedSectionsList('PrioritySection');
    }

  }

}

export default ModifiedSectionsTracker;